'use strict'

if (!customElements.get('l-rudd-legal-content')) {
	class LTARuddLegalContent extends HTMLElement {
		connectedCallback() {
			this.buildTableOfContents()
		}

		buildTableOfContents() {
			const body = this.querySelector('[data-rudd-legal-body]')
			const navigation = this.querySelector('[data-rudd-legal-toc]')
			const list = this.querySelector('[data-rudd-legal-toc-list]')

			if (!body || !navigation || !list) return

			list.replaceChildren()
			navigation.hidden = true

			const numberedOnly = this.dataset.tocNumberedOnly === 'true'
			const headings = Array.from(body.querySelectorAll('h2, h3')).filter((heading) => {
				if (!heading.textContent.trim()) return false
				if (!numberedOnly) return true

				return /^\s*\d+[.)\s]/.test(heading.textContent)
			})

			if (!headings.length) return

			const usedIds = new Set()

			headings.forEach((heading, index) => {
				const label = heading.textContent.trim()
				const baseId = heading.id || this.handleize(label) || `legal-section-${index + 1}`
				let headingId = baseId
				let duplicateIndex = 2

				while (
					usedIds.has(headingId) ||
					(document.getElementById(headingId) && document.getElementById(headingId) !== heading)
				) {
					headingId = `${baseId}-${duplicateIndex}`
					duplicateIndex += 1
				}

				heading.id = headingId
				usedIds.add(headingId)

				const item = document.createElement('li')
				const link = document.createElement('a')

				item.className = `l-rudd-legal__toc-item${heading.tagName === 'H3' ? ' l-rudd-legal__toc-item--nested' : ''}`
				link.className = 'l-rudd-legal__toc-link'
				link.href = `#${headingId}`
				link.textContent = label
				item.appendChild(link)
				list.appendChild(item)
			})

			headings[0].before(navigation)
			navigation.hidden = false
		}

		handleize(value) {
			return value
				.toLowerCase()
				.normalize('NFKD')
				.replace(/[\u0300-\u036f]/g, '')
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-+|-+$/g, '')
		}
	}

	customElements.define('l-rudd-legal-content', LTARuddLegalContent)
}
